module.exports = __webpack_public_path__ + "img/tkm.b13d1440.svg";